import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import CssBaseline from '@mui/material/CssBaseline';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import MenuIcon from '@mui/icons-material/Menu';
import Toolbar from '@mui/material/Toolbar';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from '@mui/icons-material/GitHub';
import './nav.css'
const imgLogo = {
    alt: 'Logo',
    imgUrl: '/logoUC.png'
}

const drawerWidth = 135;

function ResponsiveDrawer({ window }) {
    const [mobileOpen, setMobileOpen] = useState(false);
    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const drawer = (
        <Box>
            <Box sx={{ display: 'flex', justifyContent: 'center', backgroundColor: '#000', padding: 3 }}>
                <NavLink to={'/'}>
                    <img className='w-100 logo' src={imgLogo.imgUrl} alt={imgLogo.alt} />
                </NavLink>
            </Box>
            <Toolbar />
            <List>
                <Divider sx={{ color: '#ff0093' }} />
                <ListItem>
                    <NavLink to={'/'} className='menuItems text-decoration-none'>
                        <ListItemButton className='p-1 ms-2'>
                            About Me
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                <Divider sx={{ color: '#ff0093' }} />
                <ListItem>
                    <NavLink to={'/myskills'} className='menuItems text-decoration-none'>
                        <ListItemButton className='p-1 ms-2'>
                            My Skills
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                <Divider sx={{ color: '#ff0093' }} />
                <ListItem>
                    <NavLink to={'/projects'} className='menuItems text-decoration-none'>
                        <ListItemButton className='p-1 ms-2'>
                            Projects
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                <Divider sx={{ color: '#ff0093' }} />
                <ListItem>
                    <NavLink to={'/contact'} className='menuItems text-decoration-none'>
                        <ListItemButton className='p-1 ms-2'>
                            Contact
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                <Divider sx={{ color: '#ff0093' }} />
                <ListItem>
                    <a target="blanck" href="https://www.linkedin.com/in/ulises-catarinolo-193682235">
                        <ListItemButton className='p-1'>
                            <LinkedInIcon />
                        </ListItemButton>
                    </a>
                    <a target="blanck" href="https://github.com/lule1000">
                        <ListItemButton className='p-1 m-1'>
                            <GitHubIcon sx={{ color: '#ffffff' }} />
                        </ListItemButton>
                    </a>
                    <a target="blanck" href="/images/cv.pdf" download={'ulisesCV'}>
                        <ListItemButton className='p-1'>
                            <UploadFileIcon sx={{ color: '#ff0093' }}/>
                        </ListItemButton>
                    </a>
                </ListItem>
            </List>
        </Box>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box sx={{ display: 'flex' }}>
            <CssBaseline />
            <AppBar position='absolute' sx={{ backgroundColor: '#000' }}>
                <IconButton
                    color="inherit"
                    aria-label="open drawer"
                    edge="start"
                    onClick={handleDrawerToggle}
                    sx={{ marginLeft: 1, display: 'flex', justifyContent: 'start', display: { sm: 'none' } }}
                >
                    <MenuIcon sx={{ fontSize: '40px' }} />
                </IconButton>
            </AppBar>
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: '#000', borderLeft: '1px solid #ff0093', borderRight: '1px solid #ff0093' },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: '#000', borderLeft: '1px solid #ff0093', borderRight: '1px solid #ff0093' },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
        </Box>
    );
}

export default ResponsiveDrawer;
